import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6stwu69ae8: FaireBrandEntity = {
  token: "b_6stwu69ae8",
  type: "brand",
  name: "Enniskinn - Handmade N.Irish Selfcare",
  avatarUrl:
    "https://cdn.faire.com/fastly/2a2ecd52668a0b28daf98763465806c62471137c7c5d882dfe11217c2c50e9c5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1eb81d3134a5908710403154f14f8ed3b02f2a8f89de17623b296f37972fa2b8.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2a2ecd52668a0b28daf98763465806c62471137c7c5d882dfe11217c2c50e9c5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1eb81d3134a5908710403154f14f8ed3b02f2a8f89de17623b296f37972fa2b8.png",
  location: "GBR",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 38,
  isTopShop: true,
  isInsider: false,
  description:
    "Enniskinn is our vibrant brand of self-care products, created in rural Northern Ireland, inspired by enchanting landscapes and folklore.\n\nOur gifts share the natural scents and peaceful stories of the isle, of the hills, of the lough. When people pop in to buy a wee gift or pick-me-up for their loved ones or\nthemselves, they often stay a while to take in the colours, the aromas and the colour displays – and for a good yarn.\n\nWe love our little community and would love to share a piece of it with you. So many of our locals have put time into Enniskinn in one way or another. You’ll feel the spirit and myth of the Emerald Isle with every scent – you can find us in our local store and online. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:02.377Z",
    importedBy: "entity-db-cli",
  },
};
